module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMobile) ? _c('div', {
    attrs: {
      "id": "list-view"
    }
  }, [_c('v-container', {
    staticStyle: {
      "!important padding": "0px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_vm._l((_vm.displayImages), function(image, i) {
    return [_c('v-col', {
      key: i,
      attrs: {
        "lg": "4",
        "md": "6",
        "cols": "12"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'imageEdit',
          params: {
            id: image.id
          }
        }
      }
    }, [_c('v-card', {
      attrs: {
        "id": "card-container",
        "height": "100%"
      }
    }, [_c('v-container', {
      attrs: {
        "fill-height": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "fill-height": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": "",
        "fill-height": ""
      }
    }, [_c('img', {
      ref: 'img' + i,
      refInFor: true,
      attrs: {
        "src": _vm.getMiniUrl(image)
      },
      on: {
        "load": function($event) {
          _vm.rotateImage(_vm.$refs['img' + i], (image.exif_data && image.exif_data.orientation ? image.exif_data.orientation.value : 1), true)
        }
      }
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', [_c('v-list-item-action', [_c('v-icon', [_vm._v("watch_later")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm._f("formatDate")(image.timestamp)))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "tag_container_mobile"
    }, [_vm._l((image.categories), function(category) {
      return _c('v-chip', {
        key: category.id,
        staticClass: "tag blue lighten-2",
        attrs: {
          "small": ""
        }
      }, [_c('p', {
        staticClass: "tagp"
      }, [_c('a', {
        staticStyle: {
          "color": "black"
        },
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.searchCategory(category)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(category.name) + "\n                          ")])])])
    }), _vm._v(" "), _vm._l((image.tags), function(tag, j) {
      return _c('v-chip', {
        key: (10000 + i * 10000) + j,
        staticClass: "tag green lighten-2",
        attrs: {
          "small": ""
        }
      }, [_c('p', {
        staticClass: "tagp"
      }, [_c('a', {
        staticStyle: {
          "color": "black"
        },
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.searchTag(tag)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(tag) + "\n                          ")])])])
    })], 2)], 1)], 1)], 1)], 1)], 1)], 1)]
  })], 2)], 1)], 1) : _c('div', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "id": "grid-view"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.displayLoading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayImages), function(image, i) {
    return _c('v-flex', {
      key: image.id,
      attrs: {
        "flexbox": ""
      }
    }, [_c('v-card', {
      style: (("background-color:" + _vm.backgroundColor)),
      attrs: {
        "hover": "",
        "tile": "",
        "height": _vm.image_card_height
      }
    }, [_c('div', {
      staticClass: "check_container"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickCheck(i)
        }
      }
    }, [_c('v-icon', {
      style: (_vm.checkStyle(image.selected))
    }, [_vm._v("check_circle")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "quick_actions"
    }, [(image.location.coordinates[0] != 0 && image.location.coordinates[1] != 0 && !_vm.public) ? _c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.openMaps(image.location)
              }
            }
          }, on), [_c('v-icon', {
            staticStyle: {
              "color": "rgb(255,255,255,0.5)"
            }
          }, [_vm._v("gps_fixed")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("View Maps")])])], 1) : _vm._e(), _vm._v(" "), (image.annotation.trim() && !_vm.public) ? _c('div', {
      staticClass: "comment_container"
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.getSelectedComment(image.annotation)
              }
            }
          }, on), [_c('v-icon', {
            staticStyle: {
              "color": "rgb(255,255,255,0.5)"
            }
          }, [_vm._v("comment")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("View Comment")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "tag_container",
      on: {
        "click": function($event) {
          return _vm.clickImage(i, image.id)
        }
      }
    }, [_c('v-chip', {
      staticStyle: {
        "background-color": "rgba(0, 0, 0, 0.0)"
      },
      attrs: {
        "disabled": "",
        "cursor": "pointer"
      }
    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((image.categories), function(category) {
      return _c('v-chip', {
        key: category.id,
        class: (" tag blue " + _vm.tagTheme + " "),
        attrs: {
          "disabled": _vm.selectionMode,
          "small": "",
          "title": 'Search: Category = ' + category.name
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.clickCategory(i, category)
          }
        }
      }, [_c('p', {
        staticClass: "tagp"
      }, [_vm._v(_vm._s(category.name))])])
    }), _vm._v(" "), _vm._l((image.tags), function(tag, j) {
      return _c('v-chip', {
        key: (10000 + i * 10000) + j,
        class: (" tag green " + _vm.tagTheme + " "),
        attrs: {
          "title": 'Search: Tag = ' + tag,
          "disabled": _vm.selectionMode,
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.clickTag(i, tag)
          }
        }
      }, [_c('p', {
        staticClass: "tagp"
      }, [_vm._v(_vm._s(tag))])])
    })], 2), _vm._v(" "), _c('img', {
      ref: 'img' + i,
      refInFor: true,
      staticClass: "image",
      style: (_vm.checkStyleBorder(image.selected)),
      attrs: {
        "src": _vm.getMiniUrl(image),
        "height": _vm.thumbnailHeight
      },
      on: {
        "click": function($event) {
          return _vm.clickImage(i, image.id)
        },
        "load": function($event) {
          _vm.rotateImage(_vm.$refs['img' + i], (image.exif_data && image.exif_data.orientation ? image.exif_data.orientation.value : 1), true)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-xs-right nowrapping",
      attrs: {
        "id": "image_tags_box"
      },
      on: {
        "click": function($event) {
          return _vm.clickImage(i, image.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("formatDate")(image.timestamp)) + "\n            ")])], 1)], 1)
  })], 2)], 1)], 1), _vm._v(" "), ((_vm.selectionMode || _vm.isQuery) && !_vm.public) ? _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "green",
          staticStyle: {
            "bottom": "200px"
          },
          attrs: {
            "fab": "",
            "dark": "",
            "small": "",
            "id": "smallButtonFab"
          },
          on: {
            "click": function($event) {
              return _vm.startEditDialog()
            }
          }
        }, on), [_c('v-icon', [_vm._v("create")])], 1)]
      }
    }], null, false, 869847112)
  }, [_vm._v(" "), _c('span', [_vm._v("Edit Images")])]) : _vm._e(), _vm._v(" "), ((_vm.selectionMode || _vm.isQuery) && !_vm.public) ? _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-fab-transition', [_c('v-btn', _vm._g({
          staticStyle: {
            "bottom": "255px"
          },
          attrs: {
            "fab": "",
            "dark": "",
            "small": "",
            "color": "primary",
            "id": "smallButtonFab"
          },
          on: {
            "click": function($event) {
              return _vm.startShareDialog()
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-share-variant-outline")])], 1)], 1)]
      }
    }], null, false, 3397916832)
  }, [_vm._v(" "), _c('span', [_vm._v("Share Collection")])]) : _vm._e(), _vm._v(" "), ((_vm.selectionMode || _vm.isQuery) && !_vm.public) ? _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "red",
          staticStyle: {
            "bottom": "145px"
          },
          attrs: {
            "fab": "",
            "dark": "",
            "small": "",
            "id": "smallButtonFab"
          },
          on: {
            "click": function($event) {
              return _vm.startDeleteDialog()
            }
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }], null, false, 3171881946)
  }, [_vm._v(" "), _c('span', [_vm._v("Delete Images")])]) : _vm._e(), _vm._v(" "), (_vm.selectionMode || _vm.isQuery) ? _c('v-menu', {
    attrs: {
      "offset-x": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var menu = ref.on;

        return [_c('v-tooltip', {
          attrs: {
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var tooltip = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "blue",
                staticStyle: {
                  "bottom": "90px"
                },
                attrs: {
                  "fab": "",
                  "small": "",
                  "dark": "",
                  "id": "smallButtonFab"
                }
              }, Object.assign({}, tooltip,
                menu)), [_c('v-icon', [_vm._v("get_app")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Export Data Menu")])])]
      }
    }], null, false, 72336205)
  }, [_vm._v(" "), _c('v-list', [(_vm.selectionMode) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.clickDownload()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Download Individual Images")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.clickDownloadZip()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Download Zipped Images")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.clickDownloadCSV()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Download CSV Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectionMode) ? _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "amber",
          attrs: {
            "fab": "",
            "dark": "",
            "id": "buttonFab"
          },
          on: {
            "click": function($event) {
              return _vm.clickClear()
            }
          }
        }, on), [_c('v-icon', [_vm._v("clear")])], 1)]
      }
    }], null, false, 2374231922)
  }, [_vm._v(" "), _c('span', [_vm._v("Clear Selection")])]) : _vm._e(), _vm._v(" "), (!_vm.public) ? _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "green",
          attrs: {
            "fab": "",
            "dark": "",
            "id": "buttonFab",
            "transition": "scale-transition"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.uploadClick.apply(null, arguments)
            }
          }
        }, on), [(_vm.progress === 0) ? _c('v-icon', [_vm._v("add")]) : (_vm.progress === 100) ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        }) : _c('v-progress-circular', {
          attrs: {
            "value": _vm.progress
          }
        }, [_vm._v(_vm._s(_vm.progress))])], 1)]
      }
    }], null, false, 43750439)
  }, [_vm._v(" "), _c('span', [_vm._v("Upload Image")])]) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "right": "",
      "clipped": "",
      "persistent": "",
      "mobile-breakpoint": "800"
    },
    model: {
      value: (_vm.showEditDrawer),
      callback: function($$v) {
        _vm.showEditDrawer = $$v
      },
      expression: "showEditDrawer"
    }
  }, [(_vm.editMode) ? _c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.clearEditModal
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-h6",
    staticStyle: {
      "color": "#616161"
    }
  }, [_vm._v("Add categories & tags")]), _vm._v(" "), _c('p', {
    staticClass: "text-subtitle-1",
    staticStyle: {
      "color": "#757575"
    }
  }, [_vm._v("You are editing "), _c('b', [_vm._v(_vm._s(_vm.isQuery ? _vm.displayImages.length : _vm.selectedImages.length))]), _vm._v(" image" + _vm._s(_vm.addS()))])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showEditDialog = true
      }
    }
  }, [_vm._v("Save"), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("create")])], 1), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.getCategories,
      "item-text": "name",
      "item-value": "id",
      "label": "Categories",
      "return-object": "",
      "hide-details": "",
      "chips": "",
      "deletable-chips": "",
      "menu-props": {
        maxWidth: 225,
        closeOnContentClick: true,
        closeOnClick: true
      },
      "multiple": "",
      "hide-selected": ""
    },
    model: {
      value: (_vm.properties.categories),
      callback: function($$v) {
        _vm.$set(_vm.properties, "categories", $$v)
      },
      expression: "properties.categories"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "multiple": "",
      "label": "Tags",
      "items": _vm.getTags,
      "chips": "",
      "deletable-chips": "",
      "hide-details": "",
      "menu-props": {
        closeOnClick: true
      }
    },
    model: {
      value: (_vm.shareTags),
      callback: function($$v) {
        _vm.shareTags = $$v
      },
      expression: "shareTags"
    }
  })], 1)], 1) : _c('v-container', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.clearShareDrawer
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-reverse-transition",
      "mode": "out-in"
    }
  }, [(_vm.isShareCreate && _vm.shareCreateSuccess) ? _c('div', {
    key: "share-success"
  }, [_c('v-row', {
    staticClass: "my-8",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-h6 text-center mb-0 px-2"
  }, [_c('b', [_vm._v(_vm._s(_vm.savedShareName))]), _c('br'), _vm._v(" shared collection created\n              ")])]), _vm._v(" "), _c('v-row', [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": _vm.copyShareUrl
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("content_copy")]), _vm._v("\n                Copy share URL\n              ")], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": _vm.openSharePreview
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("open_in_new")]), _vm._v("\n                Preview\n              ")], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "block": "",
      "color": "success"
    },
    on: {
      "click": _vm.finishShareCreateSuccess
    }
  }, [_vm._v("\n                Done\n              ")])], 1)], 1) : _c('div', {
    key: "share-form"
  }, [_c('v-row', {
    staticClass: "my-10",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "mandatory": "",
      "color": "primary",
      "dense": "",
      "small": ""
    },
    model: {
      value: (_vm.isShareCreate),
      callback: function($$v) {
        _vm.isShareCreate = $$v
      },
      expression: "isShareCreate"
    }
  }, [_c('v-btn', {
    attrs: {
      "value": true,
      "small": ""
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "value": false,
      "small": ""
    }
  }, [_vm._v("Update")])], 1)], 1), _vm._v(" "), (_vm.isShareCreate) ? [_c('v-row', [_c('v-text-field', {
    attrs: {
      "label": "Shared Collection Name",
      "error-messages": _vm.shareName.trim() ? [] : ['A name is required']
    },
    model: {
      value: (_vm.shareName),
      callback: function($$v) {
        _vm.shareName = $$v
      },
      expression: "shareName"
    }
  })], 1)] : [_c('v-row', [_c('v-autocomplete', {
    attrs: {
      "label": "Shared Collections",
      "items": _vm.getShares,
      "item-text": "name",
      "item-value": "id",
      "chips": ""
    },
    model: {
      value: (_vm.selectedShare),
      callback: function($$v) {
        _vm.selectedShare = $$v
      },
      expression: "selectedShare"
    }
  })], 1)], _vm._v(" "), (_vm.isShareCreate || _vm.selectedShare) ? [_c('v-row', {
    staticClass: "mt-8"
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Shared Categories",
      "items": _vm.getCategories,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "hide-details": "",
      "menu-props": {
        maxWidth: 225,
        closeOnContentClick: true,
        closeOnClick: true
      }
    },
    on: {
      "click:close": _vm.searchClearCateogry
    },
    model: {
      value: (_vm.shareCategoryIDs),
      callback: function($$v) {
        _vm.shareCategoryIDs = $$v
      },
      expression: "shareCategoryIDs"
    }
  })], 1), _vm._v(" "), _c('v-row', [_c('v-combobox', {
    attrs: {
      "label": "Shared Tags",
      "items": _vm.getTags,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "hide-details": "",
      "menu-props": {
        closeOnClick: true
      }
    },
    model: {
      value: (_vm.shareTags),
      callback: function($$v) {
        _vm.shareTags = $$v
      },
      expression: "shareTags"
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-8",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex align-center flex-wrap",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": "",
      "max-width": "519"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mr-3",
          attrs: {
            "icon": "",
            "x-small": "",
            "aria-label": "How share filters combine"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "grey darken-2"
          }
        }, [_vm._v("info_outline")])], 1)]
      }
    }], null, false, 2957016628)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shareCombineModeHint))])]), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "mandatory": "",
      "dense": "",
      "color": "primary"
    },
    model: {
      value: (_vm.shareCombineMode),
      callback: function($$v) {
        _vm.shareCombineMode = $$v
      },
      expression: "shareCombineMode"
    }
  }, [_c('v-btn', {
    attrs: {
      "value": "or",
      "small": ""
    }
  }, [_vm._v("Any (OR)")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "value": "and",
      "small": ""
    }
  }, [_vm._v("All (AND)")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "block": "",
      "color": "success",
      "disabled": _vm.saveShareInProgress || (_vm.isShareCreate && !_vm.shareName.trim()),
      "loading": _vm.saveShareInProgress
    },
    on: {
      "click": function($event) {
        return _vm.clickSaveShareDebounced()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isShareCreate ? 'Create' : 'Save') + "\n                ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.shareUrl && !_vm.isShareCreate) ? [_c('v-row', {
    staticClass: "mt-8"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": _vm.copyShareUrl
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("content_copy")]), _vm._v("\n                  Copy URL\n                ")], 1)], 1)] : _vm._e()], 2)])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confirm Delete")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete all the selected images?  "), _c('b', [_vm._v("This action cannot be undone.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.deleteImagesIndividual()
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.showCommentDialog),
      callback: function($$v) {
        _vm.showCommentDialog = $$v
      },
      expression: "showCommentDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h4', [_vm._v("Comment ")])]), _vm._v(" "), _c('div', {
    staticClass: "h-line"
  }), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.selectedComment))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.showEditDialog),
      callback: function($$v) {
        _vm.showEditDialog = $$v
      },
      expression: "showEditDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confirm Edit")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to edit "), _c('b', [_vm._v(_vm._s(_vm.isQuery ? _vm.displayImages.length : _vm.selectedImages.length))]), _vm._v(" selected image"), _c('span', [_vm._v(_vm._s(_vm.addS()))]), _vm._v("? ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEditDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.addPropsToImages()
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.showDeleteQueryDialog),
      callback: function($$v) {
        _vm.showDeleteQueryDialog = $$v
      },
      expression: "showDeleteQueryDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confirm Delete")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete all " + _vm._s(_vm.getNumImages) + " images that satisfy this query?"), _c('b', [_vm._v("\n        This action cannot be undone.")]), _vm._v(" Type "), _c('b', [_vm._v("Delete")]), _vm._v(" below to delete the images.\n        "), _c('v-text-field', {
    attrs: {
      "label": "Delete",
      "rules": [_vm.deleteTextRule]
    },
    model: {
      value: (_vm.deleteText),
      callback: function($$v) {
        _vm.deleteText = $$v
      },
      expression: "deleteText"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteQueryDialog = false
        _vm.deleteText = ''
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red",
      "disabled": !_vm.canDeleteQuery
    },
    on: {
      "click": function($event) {
        return _vm.deleteImagesQuery()
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "file-input",
      "type": "file"
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.downloading),
      callback: function($$v) {
        _vm.downloading = $$v
      },
      expression: "downloading"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "headline ml-3"
  }, [_vm._v("Zipping & Downloading...")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("(Click anywhere to continue)")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00591e9d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageList.vue
// module id = 419
// module chunks = 1